import Vue from 'vue'
import Router from 'vue-router'
import config from "@/config/config.js";
import axios from "axios";

Vue.use(Router)
const routes = [
  {
    path: "/zk_profession",
    name: "zk_profession",
    component: resolve =>
      require(["../views/WebViews/zk_profession/zk_profession.vue"], resolve)
  },
  {
    path: "/zk_customer",
    name: "zk_customer",
    component: resolve =>
      require(["../views/WebViews/zk_customer/zk_customer.vue"], resolve)
  },
  {
    path: "/zk_tect",
    name: "zk_tect",
    component: resolve =>
      require(["../views/WebViews/zk_tect/zk_tect.vue"], resolve)
  },
  {
    path: "/zk_aboutus",
    name: "zk_aboutus",
    component: resolve =>
      require(["../views/WebViews/zk_aboutus/zk_aboutus.vue"], resolve)
  },
  {
    path: "/zk_solve",
    name: "zk_solve",
    component: resolve =>
      require(["../views/WebViews/zk_solve/zk_solve.vue"], resolve)
  },
  {
    path: "/zk_case",
    name: "zk_case",
    component: resolve => require(["../views/WebViews/zk_case/zk_case.vue"], resolve)
  },
  {
    path: "/zk_news",
    name: "zk_news",
    component: resolve =>
      require(["../views/WebViews/zk_news/zk_news.vue"], resolve)
  },
  {
    path: "/zk_index",
    name: "zk_index",
    component: resolve =>
      require(["../views/WebViews/zk_index/zk_index.vue"], resolve)
  },
  {
    path: "/",
    name: "zk_index",
    component: resolve =>
      require(["../views/WebViews/zk_index/zk_index.vue"], resolve)
  },
  {
    path: "/zk_daohang",
    name: "zk_daohang",
    component: resolve =>
      require(["../views/WebViews/zk_daohang/zk_daohang.vue"], resolve)
  }
]
const router = new Router({
  mode: "hash",
  // base: "/",
  routes
});

router.beforeEach((to, from, next) => {
  let that = this
  document.title = "西安智科软件有限公司"
  document.querySelector('meta[name="keywords"]').setAttribute('content', "")
  document.querySelector('meta[name="description"]').setAttribute('content', "")
  // console.log(to)
  let api = process.env.NODE_ENV === "development" ? "api" : ""
  axios({
    method: "GET",
    url: api + config.GetKeyWords,
    headers: { "X-Requested-With": "XMLHttpRequest" },
    params: {}
  })
    .then(response => {
      // console.log(response);
      response.data.Data.forEach((item, index) => {
        if (item.KW_Sort == 1 && (to.path == "/" || to.path == "/zk_index")) {
          test(item);
          return false;
        } else if (to.path == "/zk_customer" && item.KW_Sort == 8) {
          test(item)
          return false;
        } else if (to.path == "/zk_case" && item.KW_Sort == 2) {
          test(item);
          return false;
        }else if (to.path == "/zk_news" && item.KW_Sort == 7) {
          test(item);
          return false;
        }else if (to.path == "/zk_tect" && item.KW_Sort == 3) {
          test(item);
          return false;
        }else if (to.path == "/zk_solve" && item.KW_Sort == 4) {
          test(item);
          return false;
        }else if (to.path == "/zk_profession" && item.KW_Sort == 5) {
          test(item);
          return false;
        }else if (to.path == "/zk_aboutus" && item.KW_Sort == 6) {
          test(item);
          return false;
        }
      });

    })
    .catch(error => {
      // errFun(error);
    });
  // that.axiosRequest("GET", config.GetKeyWords, {}, res => {
  //   console.log(res);
  // });
  // GetKeyWords().then(res => {
  //   if(res.data.Result){
  //     console.log(res.data.Data)
  //     for(var i in res.data.Data){
  //       if(to.path=="/"){
  //         if(res.data.Data[i].KW_Url=="/pc_firstpage"){
  //           document.title = res.data.Data[i].Title;
  //           document
  //             .querySelector('meta[name="keywords"]')
  //             .setAttribute("content", res.data.Data[i].KW_KeyWords);
  //           document
  //             .querySelector('meta[name="description"]')
  //             .setAttribute("content", res.data.Data[i].Description);
  //         }
  //       }else if(res.data.Data[i].KW_Url==to.path){
  //         document.title = res.data.Data[i].Title;
  //         document
  //           .querySelector('meta[name="keywords"]')
  //           .setAttribute("content", res.data.Data[i].KW_KeyWords);
  //         document
  //           .querySelector('meta[name="description"]')
  //           .setAttribute("content", res.data.Data[i].Description);
  //       }
  //     }
  //   }
  // });
  next();
})

function test(item) {
  // console.log(item)
  document.title = item.KW_Note;
  document
    .querySelector('meta[name="keywords"]')
    .setAttribute("content", item.KW_KeyWords);
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", item.Description);
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js